/* eslint no-mixed-operators: 0 */

import slidesService from '../../../services/slides'
import { slidesTypes } from './slidesTypes'
import { SlideDeck, SlidesStatus } from '../../../lib/slides/types'
import { hideSlidesUploadModal, showSlidesUploadModal, closeSlidesMediaDrawer } from '../ui/uiActions'
import { mediaType as MediaType, slides as slidesConstants } from '@bt-react/constants'
import get from 'lodash/get'
import trackActions from '../tracks'
import notifications from '../notifications'
import { setMediaType } from '../room/room'
import { addEntry } from '../../../lib/audit'

export const setSlidesUser = () => async (dispatch, getState) => {

  const { room: { mediaType } } = getState()

  if (mediaType === MediaType.SCREENSHARE) {

    await dispatch(trackActions.unpublishScreen())

  }

}

export const slideSelect = slideIndex => async (dispatch, getState) => {

  const { mediaType } = getState().room
  dispatch(closeSlidesMediaDrawer())
  if (mediaType !== MediaType.SLIDES) {

    dispatch(setSlidesUser())
    dispatch(setMediaType(MediaType.SLIDES))

  }

  await getState().docs.uiDoc.update({ slidePosition: { selectedSlideStep: 0, selectedSlide: slideIndex } })

}

// deprecated - only for the old slide decks generated before logic was moved into slides-interface
export const previous = (presentation) => async (dispatch, getState) => {

  const { step, slide } = presentation.CurrentStatus()
  if (step) {

    await getState().docs.uiDoc.update({ slidePosition: { selectedSlideStep: 0, selectedSlide: slide } })

  }
  else if (slide > 1) {

    await getState().docs.uiDoc.update({ slidePosition: { selectedSlideStep: 0, selectedSlide: slide - 1 } })

  }

}

// deprecated - only for the old slide decks generated before logic was moved into slides-interface
export const next = (presentation) => async (dispatch, getState) => {

  const totalAnims = presentation.ClickCount()
  const { step, slide } = presentation.CurrentStatus()
  const totalSlides = presentation.GetContentDetails().TotalSlides

  if (step < totalAnims) {

    await getState().docs.uiDoc.update({ slidePosition: { selectedSlideStep: step + 1, selectedSlide: slide } })

  }
  else if (slide < totalSlides) {

    await getState().docs.uiDoc.update({ slidePosition: { selectedSlideStep: 0, selectedSlide: slide + 1 } })

  }

}

export const navigate = (slide, step) => async (dispatch, getState) => {

  await getState().docs.uiDoc.update({ slidePosition: { selectedSlideStep: step, selectedSlide: slide } })

}

export const setSlidePosition = position => ({ type: slidesTypes.SET_SLIDE_POSITION, payload: position })

export const processingFailed = (slideDeck) => (dispatch, getState) => {

  const defaultError = 'An error occurred please try again or contact support'
  let error
  if (slideDeck.error.indexOf('The RPC server is unavailable.') !== -1) {

    error = defaultError

  } else if (slideDeck.error.indexOf('video') !== -1) {
    
    error = 'Videos and embedded videos are not supported'
  }
  else {

    switch (slideDeck.error) {

      case 'Virus Detected':
        error = `We detected a virus with your file ${get(getState().slides, 'pendingFile.name', '')}, please try another file`
        break
      case 'Something went wrong with conversion':
        error = `There was an issue processing your slides, please try again or contact support`
        break
      default:
        error = defaultError
        break

    }

  }

  dispatch({ type: slidesTypes.PROCESSING_FAILED, payload: error })
  dispatch({ type: slidesTypes.SET_SLIDE_DECKS, payload: [ slideDeck ] })
  dispatch(showSlidesUploadModal())

}

const getApiVersion = presentation => async (dispatch, getState) => {

  const apiVersion = await slidesService.getApiVersion(presentation)
  dispatch({ type: slidesTypes.SET_API_VERSION, payload: apiVersion })

}

export const stopSlides = () => async (dispatch, getState) => {

  if (getState().room.mediaType === MediaType.SLIDES) await getState().docs.uiDoc.update({ mediaType: MediaType.WEBCAM })

}

export const setActiveDeck = activeDeckId => ({ type: slidesTypes.SET_ACTIVE_DECK, payload: activeDeckId })

export const removeSlides = () => async (dispatch, getState) => {

  const { slides: { activeDeck }, config: { roomname } } = getState()
  if (activeDeck) {

    await slidesService.removeSlides(roomname, activeDeck)
    dispatch({ type: slidesTypes.SET_SLIDE_DECKS, payload: [] })
    dispatch(setActiveDeck(null))
    dispatch(stopSlides())

  }

}

export const confirmSlidesRemoval = () => async (dispatch, getState) => {

  dispatch(removeSlides())
  dispatch({ type: slidesTypes.HIDE_SLIDES_CONFIRM_MODAL })

}

export const attemptRemoveSlides = () => ({ type: slidesTypes.SHOW_SLIDES_CONFIRM_MODAL })

export const cancelRemoveSlides = () => ({ type: slidesTypes.HIDE_SLIDES_CONFIRM_MODAL })

export const setSlides = doc => ({ type: slidesTypes.SET_SLIDES, payload: doc })

export const onUploadProgress = (progress) => ({ type: slidesTypes.UPLOAD_PROGRESS, payload: progress })

export const onProcessingProgress = (progress) => ({ type: slidesTypes.PROCESSING_PROGRESS, payload: progress })

export const setSlideDecks = (slideDecks: SlideDeck[]) => async (dispatch, getState) => {

  const { slides: { processingProgress, pendingSlidesId, featureImageRequested }, config } = getState()
  const latestSlideDeck = slideDecks.sort((a, b) => b.timeStamp.localeCompare(a.timeStamp))[0]

  if (!latestSlideDeck) {

    dispatch({ type: slidesTypes.SET_SLIDE_DECKS, payload: [latestSlideDeck] })
    return

  }

  if ([SlidesStatus.CONVERTING, SlidesStatus.VIRUS_SCANNING].includes(latestSlideDeck.status)) {

    if (latestSlideDeck.percentageComplete >= processingProgress) {

      dispatch(onProcessingProgress(latestSlideDeck.percentageComplete))

    }

  }

  if (latestSlideDeck.status === SlidesStatus.COMPLETE) {

    await getState().docs.uiDoc.update({ pendingSlidesId: null })
    dispatch({ type: slidesTypes.SET_SLIDE_DECKS, payload: [] })
    dispatch({ type: slidesTypes.SET_SLIDE_DECKS, payload: [latestSlideDeck] })
    dispatch({ type: slidesTypes.PROCESSING_ENDED })
    dispatch(getApiVersion(latestSlideDeck))
    // only the original uploader will have this
    if (featureImageRequested && latestSlideDeck.slidesId === featureImageRequested) {

      try {

        await slidesService.setFeatureImage(config.roomname, featureImageRequested)

      }
      catch (e) {

        console.log(e.message)

      }
      dispatch(({ type: slidesTypes.FEATURE_IMAGE_REQUEST_COMPLETED }))

    }

  }

  if (latestSlideDeck.status === SlidesStatus.FAILED) {

    await getState().docs.uiDoc.update({ pendingSlidesId: null })
    if (pendingSlidesId && pendingSlidesId === latestSlideDeck.slidesId) {

      // this means this user initiated the upload
      dispatch(processingFailed(latestSlideDeck))

    }
    else {

      // other presenters
      dispatch({ type: slidesTypes.PROCESSING_ENDED })
      dispatch({ type: slidesTypes.SET_SLIDE_DECKS, payload: [latestSlideDeck] })

    }

  }

}

export const setPendingSlidesId = (pendingSlidesId) => (dispatch, getState) => {

  if (pendingSlidesId) {

    const { room } = getState()
    if (room.mediaType === MediaType.SLIDES) {

      dispatch(notifications.addNotification('Room will revert back to webcams while slides are being converted', 5000, 'notification-webcam-revert'))
      setTimeout(() => dispatch(stopSlides()), 5000)

    }

  }
  dispatch(({ type: slidesTypes.SET_PENDING_SLIDES_ID, payload: pendingSlidesId }))

}

export const saveCancelToken = (cancelToken) => ({ type: slidesTypes.CANCEL_TOKEN_GENERATED, payload: cancelToken })

export const uploadSlides = (slidesFile: File | null) => async (dispatch, getState) => {

  let slidesId
  const preventUnload = (e) => {

    e.preventDefault()
    e.returnValue = true

  }
  window.addEventListener('beforeunload', preventUnload)
  const { config, slides } = getState()
  let cancelTokenReceived = false
  let canceled = false
  dispatch({ type: slidesTypes.UPLOAD_STARTED, payload: slidesFile })
  dispatch(hideSlidesUploadModal())
  try {

    slidesId = await slidesService.uploadSlides(config.roomname, slidesFile, ({ loaded, total, cancelToken }) => {

      if (!cancelTokenReceived) {

        cancelTokenReceived = true
        dispatch(saveCancelToken(cancelToken))

      }
      dispatch(onUploadProgress(loaded * (100 / total)))

    })

  }
  catch (e) {

    if (e.message === slidesConstants.slidesUploadCancel) {

      canceled = true

    }
    else {

      addEntry('PresenterService', 'SlidesScreen', `Slides upload error: ${e}`)
      // handle unexpected error

    }

  }

  if (!canceled) {

    await getState().docs.uiDoc.update({ pendingSlidesId: slidesId, slidePosition: { selectedSlide: null, selectedSlideStep: 0 } })

    dispatch({ type: slidesTypes.UPLOAD_ENDED, payload: slidesId })
    dispatch(onProcessingProgress(5))
    setTimeout(() => {

      const state = getState()
      if (!state.slides.hasError && !state.processingProgress || state.processingProgress < 10) {

        dispatch(onProcessingProgress(10))

      }

    }, 10000)

    if (slides.setAsFeatureImage) {

      dispatch(({ type: slidesTypes.FEATURE_IMAGE_REQUESTED, payload: slidesId }))

    }

  }

  window.removeEventListener('beforeunload', preventUnload)

}

export const listenersAdded = () => ({ type: slidesTypes.SLIDE_LISTENERS_ADDED })

export const cancelUpload = () => (dispatch, getState) => {

  const { slides } = getState()
  if (slides.cancelToken) {

    slides.cancelToken.cancel()
    dispatch({ type: slidesTypes.UPLOAD_CANCELLED })

  }

}

export const setAsFeatureImage = () => ({ type: slidesTypes.SET_FEATURE_IMAGE })
export const unsetAsFeatureImage = () => ({ type: slidesTypes.UNSET_FEATURE_IMAGE })
